<!--
 * @Description: 
 * @Author: 琢磨先生
 * @Date: 2025-10-27 19:54:47
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2025-10-28 19:41:56
-->

<template>
  <el-card class="box query">
    <el-form :model="query" ref="query" :inline="true">
      <el-form-item label="名称">
        <el-input
          v-model="q"
          placeholder=""
          clearable
          style="width: 300px"
          @clear="onClear"
          @input="onSearch"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <!-- <el-button type="primary" round @click="onSearch" icon="search"
          >查询</el-button
        > -->

        <el-popconfirm
          title="确定要从OA同步部门信息吗？"
          placement="bottom"
          width="400" v-if="is_can_sync"
          @confirm="syncDeptHandle"
        >
          <template #reference>
            <el-button round :loading="syncing">从OA更新部门</el-button>
          </template>
        </el-popconfirm>
      </el-form-item>
    </el-form>
  </el-card>

  <el-card class="box data" v-loading="loading">
    <el-table
      :data="dataList"
      stripe
      border
      style="width: 100%"
      row-key="id"
      :expand-row-keys="expandKeys"
    >
      <el-table-column prop="name" label="名称" min-width="200" />
      <el-table-column prop="fullPath" label="完整路径" min-width="200" />
      <el-table-column prop="type" label="类型" width="120" />
      <el-table-column label="短信通知专员" width="180">
        <template #default="{ row }">
          <el-tag v-if="row.isSmsReport" type="success">开启</el-tag>
          <div v-else>否</div>
        </template>
      </el-table-column>
      <el-table-column label="市场专员" min-width="300">
        <template #default="scope">
          <el-tag
            type="info"
            size="small"
            effect="plain"
            v-for="x in scope.row.zhuanyuanList"
            :key="x"
            closable
            @close="onDelete(scope.row, x)"
            style="
              margin-right: 20px;
              color: var(--el-table-text-color);
              border: none;
              border-bottom: 1px dotted var(--el-color-primary);
              border-radius: 0;
              background: transparent;
            "
            >{{ `${x.consumerName}(${x.consumerMobile})` }}
            {{ x.isReceiveSms ? "[接收短信]" : "" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{ row }">
          <el-button
            type="primary"
            link
            size="small"
            @click="onEdit(row)"
            icon="edit"
            >修改/设置专员</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </el-card>
  <edit-zhuanyuan
    :item="current_item"
    @closed="current_item = null"
    @success="onSuccess"
  ></edit-zhuanyuan>
</template>

<script>
import EditZhuanyuan from "./edit_zhuanyuan.vue";

export default {
  components: { EditZhuanyuan },
  data() {
    return {
      loading: false,
      dataList: [],
      current_item: null,
      expandKeys: [],
      q: "",
      syncing: false,
      treeList: [], //
      is_can_sync: false,

    };
  },
  created() {
    this.is_can_sync = this.$power("admin/v1/dept/sync");

    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      // 使用 then/catch/finally 而非 async/await
      this.$http
        .get("/admin/v1/dept/tree")
        .then((res) => {
          if (res.code === 0) {
            this.dataList = res.data;
            this.treeList = res.data;
            this.expandKeys = [this.dataList[0].id];
          }
        })
        .catch((err) => {
          console.error("loadData error:", err);
          this.dataList = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onEdit(item) {
      this.current_item = item;
    },
    /**
     *
     * @param {*} a
     * @param {*} b
     */
    onDelete(e, c) {
      this.$confirm(
        `您确定要删除【${e.name}】专员【${c.consumerName}】？`,
        "温馨提示"
      ).then(() => {
        this.$http
          .get(`admin/v1/dept/del_zy?deptId=${e.id}&consumerId=${c.consumerId}`)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.loadData();
            }
          });
      });
    },

    /**
     * 同步
     */
    syncDeptHandle() {
      this.syncing = true;
      this.$http
        .get(`admin/v1/dept/sync`)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.loadData();
          }
        })
        .finally(() => {
          this.syncing = false;
        });
    },

    /**
     *
     */
    onSuccess() {
      if (this.q) {
        this.onSearch();
      } else {
        this.loadData();
      }
    },

    onClear() {
      this.dataList = this.treeList;
      //   this.loadData();
    },

    onSearch() {
      //   this.loadData()
      if (!this.q) {
        return;
      }
      this.loading = true;
      this.$http
        .get("admin/v1/dept?q=" + this.q)
        .then((res) => {
          if (res.code == 0) {
            this.dataList = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>